// extracted by mini-css-extract-plugin
export default {"LoginTitle":"RijTIfn2E_EHrYxL5w2d","LoginForm":"jEclsMAKEuotDUyymmeI","ForgotPassword":"qcHWCAb13DjzmXsXVxjQ"};